// extracted by mini-css-extract-plugin
export var cartContainer = "_pm-4";
export var gray = "_pm-1";
export var itemContainer = "_pm-2";
export var itemDetails = "_pm-3";
export var strong = "_pm-0";